<template>
  <div>
    <page-main
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      :type="type"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        :amzSkuMaterialGroup="amzSkuMaterialGroup"
      >
        <slot>
          <el-button class="ml-2" size="small" type="primary" @click="addMaterial()"
            >新增物料</el-button
          >
          <el-button class="ml-2" size="small" type="success" @click="submit()"
            >确认选择</el-button
          >
          <el-button class="ml-2" size="small" @click="close()">取消</el-button>
        </slot>
      </page-header>
      <pagination
        perfect
        size="mini"
        align="right"
        slot="pager"
        :layouts="['Total', 'Sizes', 'PrevPage', 'JumpNumber', 'NextPage']"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
  </div>
</template>

<script>
import PageMain from './main'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
export default {
  mixins: [BaseTable],
  components: {
    PageHeader,
    PageMain,
  },
  props: {
    amzSkuMaterialGroup: { type: String, default: '' },
    productLine: { type: String, default: '' },
    type: String,
  },
  data() {
    return {
      usePage: true,
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .materialInfoListApi({
          ...form,
          ...this.page,
          productLine: this.productLine,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    choiceData() {
      return this.$refs.main.choiceData()
    },
    close() {
      this.$emit('close')
    },
    submit() {
      this.$emit('confirm')
    },
    addMaterial() {
      this.$emit('addMaterial')
    },
    reloadList() {
      this.$refs.header.query()
    },
  },
}
</script>
